import { NavLink } from "react-router-dom";
import { FiBookOpen, FiLogOut } from "react-icons/fi";

// Nếu có logo thì chèn vào đây
// import Logo from "../../assets/logo.png";

export default function TeacherSidebar({ onLogout }) {
  return (
    <aside
      className="hidden md:flex flex-col min-h-screen px-4 py-6 z-20"
      style={{
        width: 220,
        background: "rgb(var(--color-card))",
        borderRight: "1px solid rgb(var(--color-border))",
        boxShadow: "var(--shadow-main)",
        borderRadius: "var(--radius-main)",
      }}
    >
      {/* Header */}
      <div className="mb-10">
        {/* <img src={Logo} alt="Logo" className="h-10 mb-2" /> */}
        <div
          className="font-bold text-2xl mb-1 flex items-center gap-2 tracking-tight"
          style={{
            color: "rgb(var(--color-primary))",
            letterSpacing: "-0.5px",
          }}
        >
          👨‍🏫 Giáo viên
        </div>
        <div
          className="text-xs font-medium"
          style={{
            color: "rgb(var(--color-text2))",
          }}
        >
          Trung tâm Anh ngữ
        </div>
      </div>
      {/* Navigation */}
      <nav className="flex flex-col gap-1">
        <NavLink
          to="/teacher/classes"
          className="flex items-center gap-2 px-3 py-2 transition font-medium"
          style={({ isActive }) => ({
            borderRadius: "var(--radius-main)",
            fontWeight: isActive ? 600 : 500,
            fontSize: 15,
            color: isActive
              ? "rgb(var(--color-menu))"
              : "rgb(var(--color-text2))",
            background: isActive
              ? "rgba(var(--color-primary),0.10)"
              : "transparent",
            boxShadow: isActive ? "var(--shadow-main)" : "none",
            transition: "background 0.15s, color 0.15s",
          })}
        >
          <FiBookOpen /> Lớp học của tôi
        </NavLink>
        {/* Thêm NavLink khác */}
      </nav>
      {/* Footer/Logout */}
      <div className="mt-auto pt-10">
        <button
          onClick={onLogout}
          className="flex items-center gap-2 w-full text-left px-3 py-2 font-medium transition"
          style={{
            borderRadius: "var(--radius-main)",
            color: "rgb(255 54 54)",
            background: "transparent",
            cursor: "pointer",
            transition: "background 0.15s",
          }}
          onMouseOver={e =>
            (e.currentTarget.style.background = "rgba(255,54,54,0.08)")
          }
          onMouseOut={e =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          <FiLogOut /> Đăng xuất
        </button>
      </div>
    </aside>
  );
}
